__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "marketplacePortalHost";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@design-systems/canvas-ui", "8.1.6", () => (Promise.all([__webpack_require__.e(7786), __webpack_require__.e(6783), __webpack_require__.e(8235), __webpack_require__.e(8283), __webpack_require__.e(9205)]).then(() => (() => (__webpack_require__(736783))))));
			register("@emotion/react", "11.10.6", () => (Promise.all([__webpack_require__.e(4747), __webpack_require__.e(8283), __webpack_require__.e(9536)]).then(() => (() => (__webpack_require__(559536))))));
			register("@emotion/styled", "11.10.6", () => (Promise.all([__webpack_require__.e(8283), __webpack_require__.e(2404), __webpack_require__.e(8950)]).then(() => (() => (__webpack_require__(798950))))));
			register("@marketplace-portal/shared/config/pilotSellerLaunchAccessConfig", "1.0.0", () => (__webpack_require__.e(9900).then(() => (() => (__webpack_require__(629900))))));
			register("@marketplace-portal/shared/flag", "1.0.0", () => (__webpack_require__.e(2474).then(() => (() => (__webpack_require__(382474))))));
			register("@marketplace-portal/shared/services/v1/fireflyInsights", "1.0.0", () => (Promise.all([__webpack_require__.e(2801), __webpack_require__.e(3372)]).then(() => (() => (__webpack_require__(643372))))));
			register("@tanstack/react-query", "4.29.5", () => (Promise.all([__webpack_require__.e(3489), __webpack_require__.e(8283)]).then(() => (() => (__webpack_require__(893489))))));
			register("axios", "1.21.0", () => (__webpack_require__.e(9843).then(() => (() => (__webpack_require__(29843))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8108), __webpack_require__.e(8283)]).then(() => (() => (__webpack_require__(328108))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(7571), __webpack_require__.e(8283), __webpack_require__.e(9205), __webpack_require__.e(7512)]).then(() => (() => (__webpack_require__(407571))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(1025), __webpack_require__.e(8283), __webpack_require__.e(9205)]).then(() => (() => (__webpack_require__(411025))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6685).then(() => (() => (__webpack_require__(666685))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};